<template>
  <div class="page-content">
    <div class="system-list">
      <el-tree
        :data="treeData"
        class="system-tree"
        :default-expand-all="true"
        :expand-on-click-node="false"
        :props="{
          children: 'children',
          label: 'name',
        }"
        @node-click="handleChangeSystemList"
      >
      </el-tree>
    </div>
    <div class="menu-list">
      <div
        class="system-list"
        v-for="list in listMenuHouseGroup"
        :key="list.id"
      >
        <p class="title">{{ list.name }}</p>
        <div
          class="system-item"
          v-for="listItem in list.list"
          :key="listItem.id"
          @click="handleChooseMenu(listItem)"
        >
          {{ listItem.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "select",
  data() {
    return {
      listCompaniesOfIJoined: [],
      activeCompany: "",
      treeData: [
        {
          id: 1,
          aaa: "aaa",
          name: "一级 1",
          children: [
            {
              id: 2,
              aaa: "aaa",
              name: "一级 2",
              children: [
                {
                  id: 3,
                  aaa: "aaa",
                  name: "一级 3",
                },
              ],
            },
          ],
        },
      ],
      listMenuHouseGroup: [
        {
          name: "123",
          list: [
            {
              id: "1",
              name: "123",
            },
          ],
        },
      ],
    };
  },
  created() {
    this.handleSelectSystem();
  },
  methods: {
    // 拿企业
    async handleSelectSystem() {
      let listCompaniesOfIJoined = await this.$api.user.listCompaniesOfIJoined(
        this.$moment(new Date()).format("yyyy/MM/DD HH:mm:ss"),
        this.$moment(new Date()).format("yyyy/MM/DD HH:mm:ss"),
        1
      );
      if (listCompaniesOfIJoined.success) {
        this.handleGetListMenuHouseGroup(listCompaniesOfIJoined.data[0].id);
        this.activeCompany = listCompaniesOfIJoined.data[0].id;
        this.treeData = listCompaniesOfIJoined.data;
      }
    },
    // 切换仓库组
    handleGetListMenuHouseGroup(id) {
      this.$api.menu.listMenuHouseGroup(id, "123").then((res) => {
        if (res.success) {
          let apiArr = [];
          let data = res.data;
          this.listMenuHouseGroup = data;
          for (let i = 0; i < data.length; i++) {
            apiArr.push(this.$api.menu.listMenuHouse(data[i].id));
          }
          Promise.all(apiArr).then((res) => {
            if (res[0].success) {
              for (let i = 0; i < res.length; i++) {
                this.listMenuHouseGroup.list = res[i].data;
              }
            }
          });
        }
      });
    },
    // 切换企业
    handleChangeSystemList(node, data) {
      console.log(node, data);
      this.handleGetListMenuHouseGroup(node.id);
    },
    // 选菜单登录 this.$store.commit('user/SET_menuGroup', res.data)
    handleChooseMenu(list) {
      // this.$router.push('/')
      // window.location.replace(`${window.baseConfig.loginServeUrl}?account=${this.loginForm.userName}&password=${this.loginForm.password}&redirectUrl=${window.location.href}`)
      this.$api.getMyMenu(list.id, "energy").then((res) => {
        if (res.success) {
          this.$store.commit("user/SET_menuGroup", res.data);
          // this.$router.push('/')
          window.location.replace(
            `${window.baseConfig.loginServeUrl}?account=${this.loginForm.userName}&password=${this.loginForm.password}&redirectUrl=${window.location.href}`
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  display: flex;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 24px;
}

.page-content {
  p {
    margin: 0;
  }
  display: flex;
  .system-list {
    box-sizing: border-box;
    width: 200px;
  }
  .menu-list {
    width: calc(100% - 200px);
    box-sizing: border-box;
    border-left: 1px solid #ddd;
    padding: 0 20px;
    .system-list {
      margin-bottom: 20px;
      .title {
        margin-bottom: 12px;
        text-align: left;
        font-size: 14px;
        font-family: "PingFangSC-Regular, PingFang SC";
        font-weight: 400;
        color: #0080ff;
        line-height: 20px;
      }
      .system-item {
        margin: 0 12px 12px 0;
        float: left;
        width: 180px;
        height: 120px;
        line-height: 120px;
        border-radius: 4px;
        text-align: center;
        border: 1px solid #dddddd;
        color: #333333;
        &:hover {
          background: #e6f7ff;
          border-radius: 4px;
          border: 1px solid #017fff;
        }
      }
    }
  }
}

::v-deep .el-tree-node__content {
  height: 42px;
  &:hover {
    background: #e6f7ff !important;
    color: #333 !important;
  }
}

::v-deep .el-tree-node:focus > .el-tree-node__content {
  background: #e6f7ff;
  border-right: 3px solid #0080ff;
}
</style>
